import AddBGPSegment from "../../../modules/custom/addBGPSegment/BGPSegments";
import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../../redux/hooks';
import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap'; // Importar Spinner para mostrar mientras carga

const AddBGPSEGMENTS: React.FC = () => {
  const ListaPermisosTenant = useAppSelector(state => state.ListPermissionSlice.Permissions);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true); // Estado de loading

  // Validación de permisos y redirección con estado de carga
  useEffect(() => {
    const delay = setTimeout(() => {
      if (ListaPermisosTenant.length > 0) {
        setLoading(false); // Detener el estado de loading cuando los permisos estén cargados

        if (
          !ListaPermisosTenant.includes('Ctx.BGP.Add') &&
          !ListaPermisosTenant.includes('Ctx.BGP.List') &&
          !ListaPermisosTenant.includes('Ctx.BGP.Delete')
        ) {
          // Si no tiene ninguno de estos permisos, validamos si tiene Home.Status
          if (ListaPermisosTenant.includes('Home.Status')) {
            navigate('/dashboard/status');
          } else {
            // Si no tiene Home.Status, redirigimos a cloudConnectivity
            navigate('/cloudConnectivity');
          }
        }
      }
    }, 1000); // Retraso de 1 segundo para simular la validación de permisos

    // Limpiar el timeout si el componente se desmonta
    return () => clearTimeout(delay);
  }, [ListaPermisosTenant, navigate]);

  // Mostrar spinner mientras se validan los permisos
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <div className="text-marino" style={{ marginTop: '20px', fontSize: '18px', color: '#007bff' }}>We are validating your permissions...</div>
      </div>
    );
  }

  return (
    <>
      <div className='card mb-5 mb-xl-5'>
        <AddBGPSegment />
      </div>
    </>
  );
}

export { AddBGPSEGMENTS };
